/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description nearMe constants
 */

export const START_FETCHING_LISTABLES = '@@nzr/nearMe/START_FETCHING_LISTABLES'
export const CANCEL_FETCHING_LISTABLES = '@@nzr/nearMe/CANCEL_FETCHING_LISTABLES'
export const RECEIVE_LISTABLES = '@@nzr/nearMe/RECEIVE_LISTABLES'
export const CLEAR_LISTABLES = '@@nzr/nearMe/CLEAR_LISTABLES'
export const ERROR_FETCHING_LISTABLES = '@@nzr/nearMe/ERROR_FETCHING_LISTABLES'
export const DONE_FETCHING_LISTABLES = '@@nzr/nearMe/DONE_FETCHING_LISTABLES'

export const SET_PROPERTY_TYPE = '@@nzr/nearMe/SET_PROPERTY_TYPE'

export const RESET = '@@nzr/nearMe/RESET'

export const APARTMENTS = 'apartments'
export const CHEAP_APARTMENTS = 'cheap-apartments'
export const CONDOS = 'condos'
export const HOUSES = 'houses'
export const LUXURY_APARTMENTS = 'luxury-apartments'
export const MOVE_IN_SPECIAL = 'move-in-special'
export const NO_DEPOSIT = 'no-deposit'
export const PET_FRIENDLY_APARTMENTS = 'pet-friendly-apartments'
export const ROOMS = 'rooms'
export const SHORT_TERM_RENTALS = 'short-term-rentals'
